import Navigation from "../components/Navigation";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const INSIGHTS = [
  {
    slug: "ki-agenten-versicherungsvertrieb",
    category: "Vertrieb & KI",
    title:
      "Wenn die KI den Versicherer auswählt: Was Vermittler und Versicherer jetzt wissen müssen",
    excerpt:
      "Accenture hat 25.590 Menschen in 16 Ländern gefragt, wie sie künftig Versicherungen aussuchen: 37 Prozent fanden über KI Anbieter, die sie nicht kannten, 47 Prozent bessere Produkte als allein, und bei Millennials liegt die KI vor dem Vergleichsportal. Was das für Versicherer und Vermittler bedeutet, und warum die neue Abkürzung „AEO“ dieselbe Falle ist wie die alten SEO-Tricks.",
    publishedDate: "2026-09-03",
    readingTime: "10 Min Lesezeit",
  },
  {
    slug: "modell-landschaft-sommer-2026",
    category: "AI & Tools",
    title: "Das Modell-Beben im Sommer 2026: Familien, Zugangsklassen, Preisverfall",
    excerpt: "Zwischen Juni und August 2026 haben die großen KI-Häuser ihre Angebote grundlegend umgebaut: neue Modellfamilien, eine Leistungsklasse oberhalb der bisherigen Spitze, Denk-Regler für Nutzer und ein Preisverfall, der das Kostenargument gegen KI beerdigt. Die vier strukturellen Verschiebungen hinter den Releases, und die vier Prüffragen, mit denen Sie jedes künftige Release in Minuten einordnen.",
    publishedDate: "2026-08-28",
    readingTime: "11 Min Lesezeit",
  },
  {
    slug: "arbeitsagenten-statt-chat",
    category: "KI in der Praxis",
    title: "Von der Antwort zum Arbeitsergebnis: KI-Agenten übernehmen ganze Aufgaben",
    excerpt: "Seit diesem Sommer liefern die großen Assistenten fertige Arbeitsprodukte statt Antworten: Dokumente, Tabellen, Präsentationen, Dashboards. Damit wird sauberes Delegieren zur Kernkompetenz, und die disziplinierte Abnahme zur Pflicht. Die vier Agenten-Klassen, die vier Elemente eines guten Maschinen-Briefings, und die Regeln, mit denen der Einstieg gelingt, ohne dass es teuer wird.",
    publishedDate: "2026-08-28",
    readingTime: "11 Min Lesezeit",
  },
  {
    slug: "open-weight-sommer-2026",
    category: "AI Foundations",
    title: "Der Open-Weight-Sommer: Offene Modelle erreichen die Spitze",
    excerpt: "In acht Wochen haben vier chinesische Labore die Gewissheit beerdigt, dass offene Modelle strukturell hinterherlaufen: Erstmals führt ein frei verfügbares Modell eine große Coding-Rangliste an. Die Preise fallen auf Centbeträge, Frontier-nahe Intelligenz läuft auf Firmenrechnern. Was das für Datensouveränität und Ihre Modellstrategie heißt, und wo die ehrlichen Haken liegen.",
    publishedDate: "2026-08-28",
    readingTime: "10 Min Lesezeit",
  },
  {
    slug: "ki-orchestrierte-angriffe",
    category: "Sicherheit & KI",
    title: "Wenn der Angreifer nicht mehr müde wird: KI-orchestrierte Angriffe",
    excerpt: "Ende 2025 wurde erstmals eine Spionage-Kampagne dokumentiert, in der eine KI 80 bis 90 Prozent der Angriffsschritte selbst ausführte. Damit endet der alte Schutz des Mittelstands, zu klein für professionelle Angreifer zu sein. Was sich an der Angreifer-Ökonomie ändert, was die Anbieter dagegen bauen, und welche unglamourösen Prioritäten jetzt zählen.",
    publishedDate: "2026-08-28",
    readingTime: "10 Min Lesezeit",
  },
  {
    slug: "mein-ki-system",
    category: "KI in der Praxis",
    title:
      "Wie ich wirklich mit KI arbeite: Die Architektur hinter einem persönlichen Agenten-System",
    excerpt:
      "Die meisten nutzen KI wie ein besseres Suchfeld. Ich arbeite seit über einem Jahr mit einem orchestrierten Team aus KI-Agenten, persistentem Gedächtnis und einem Verbindungs-Standard zu meinen Systemen. Die Architektur dahinter — auf Prinzipien-Ebene, mit Skizzen, damit Sie die Bauidee übernehmen können. Übrigens: Dieser Text ist selbst mit diesem System entstanden.",
    publishedDate: "2026-05-26",
    readingTime: "14 Min Lesezeit",
  },
  {
    slug: "google-ai-search-mythbusting",
    category: "AI & Search",
    title:
      "Google hat alle AI-SEO-Hacks entwertet. Hier ist, was wirklich zählt.",
    excerpt:
      "Im Mai 2026 hat Google seinen offiziellen AI-Optimization-Guide veröffentlicht — und damit die wichtigsten AEO/GEO-Versprechen am Markt namentlich widerlegt. llms.txt, Content-Chunking, AI-spezifisches Schema. Alles unnötig laut Google. Hier ist die Mythbusting-Liste mit Original-Zitaten — und was Sie stattdessen tun sollten.",
    publishedDate: "2026-05-26",
    readingTime: "8 Min Lesezeit",
  },
  {
    slug: "llm-tool-landschaft-2026",
    category: "AI & Tools",
    title:
      "Die LLM-Tool-Landschaft 2026: Claude, ChatGPT, Gemini, DeepSeek, Llama — wer macht eigentlich was?",
    excerpt:
      "Die Frage „Welches LLM ist das Beste?\" ist im B2B-Mittelstand falsch gestellt. Es gibt fünf Camps mit unterschiedlichen Stärken, Pricing-Strategien und Compliance-Profilen. Hier ist die Landkarte, die ich bei jedem Kunden-Onboarding zeichne — plus fünf Use-Case-Empfehlungen, die in 80 % der Mittelstands-Setups funktionieren.",
    publishedDate: "2026-05-26",
    readingTime: "11 Min Lesezeit",
  },
  {
    slug: "llms-erklaert-fuer-entscheider",
    category: "AI Foundations",
    title:
      "LLMs erklärt für Entscheider: Was Transformer wirklich tun (und was nicht)",
    excerpt:
      "In jedem zweiten Strategie-Gespräch der letzten 18 Monate kam der Moment, in dem klar wurde: Der Entscheider kauft KI, ohne zu wissen, was technisch passiert. Das ist nicht peinlich — es ist verbreitet. Und es ist die häufigste Ursache für Fehlinvestitionen im sechsstelligen Bereich. Dieser Artikel erklärt LLMs ohne Mathematik und mit dem Wissen, das Sie brauchen, um Anbieter zu prüfen.",
    publishedDate: "2026-05-26",
    readingTime: "10 Min Lesezeit",
  },
  {
    slug: "eu-ai-act-2026",
    category: "Regulatorik",
    title:
      "EU AI Act 2026: Was nach dem Digital-Omnibus-Deal wirklich gilt — und was Mittelständler jetzt tun müssen",
    excerpt:
      "Der Digital Omnibus ist beschlossen und verschiebt die Hochrisiko-Pflichten auf Dezember 2027. Am 2. August 2026 ist trotzdem ein Teil des AI Act scharf geworden: die Transparenzpflichten aus Artikel 50. Welche vier Fälle sie kennen, was Sie kennzeichnen müssen und was gerade nicht.",
    publishedDate: "2026-05-26",
    readingTime: "12 Min Lesezeit",
  },
  {
    slug: "dsgvo-art-35-ki",
    category: "Regulatorik",
    title:
      "DSGVO Art. 35 und KI: Wann eine Datenschutz-Folgenabschätzung Pflicht wird — und warum sie nicht die FRIA ersetzt",
    excerpt:
      "DPIA und FRIA werden ständig verwechselt. Die Verwechslung ist teuer: Wer glaubt, eine Datenschutz-Folgenabschätzung erfülle automatisch die Grundrechte-Folgenabschätzung des AI Act, baut eine Compliance-Lücke ein. Wann eine DPIA für KI Pflicht ist, was die FRIA zusätzlich verlangt — und warum die „Absorptionsklausel\" ein Dokumentations-Trick ist, keine Gleichsetzung.",
    publishedDate: "2026-05-26",
    readingTime: "11 Min Lesezeit",
  },
  {
    slug: "prompt-engineering-mittelstand",
    category: "KI in der Praxis",
    title:
      "Prompt-Engineering im Mittelstand: 5 Patterns, die wirklich funktionieren (aus 12 Mandaten)",
    excerpt:
      "Die meisten Prompt-Engineering-Kurse lehren Tricks, die in sechs Monaten veraltet sind — „biete dem Modell Trinkgeld an“, „droh ihm“. Das ist Aberglaube, kein Engineering. Was bleibt, sind fünf strukturelle Patterns, die seit drei Jahren funktionieren. Mit konkreten Vorher-Nachher-Beispielen aus der Praxis — und dem häufigsten Fehler, den fast jeder Mittelständler macht.",
    publishedDate: "2026-05-26",
    readingTime: "10 Min Lesezeit",
  },
  {
    slug: "mcp-erklaert",
    category: "AI Infrastructure",
    title:
      "MCP erklärt: Der USB-Standard, der KI mit Ihren Unternehmens-Systemen verbindet",
    excerpt:
      "MCP ist die wichtigste Infrastruktur-Entwicklung im KI-Bereich seit den LLMs selbst — und fast kein Mittelständler kennt sie. Dabei löst sie genau das Problem, an dem die meisten KI-Projekte scheitern: die Anbindung der KI an die eigenen Systeme. Hier ist MCP ohne Tech-Kauderwelsch erklärt — mit der einen Analogie für jeden Geschäftsführer und den Sicherheitsfragen, die Sie vor dem Einsatz stellen müssen.",
    publishedDate: "2026-05-26",
    readingTime: "11 Min Lesezeit",
  },
  {
    slug: "rag-im-mittelstand",
    category: "AI Infrastructure",
    title:
      "RAG im Mittelstand: Wann sich eine Vektordatenbank lohnt — und wann nicht",
    excerpt:
      "RAG ist die meistverkaufte und am häufigsten falsch eingesetzte KI-Architektur im Mittelstand. Richtig gemacht, löst sie das Halluzinations- und Aktualitätsproblem und liefert auditierbare Antworten aus Ihren Dokumenten. Falsch gemacht, ist sie teurer Aufwand für ein Problem, das ein simples Kontextfenster besser gelöst hätte. Die ehrliche Entscheidungsmatrix inklusive Rechenbeispiel.",
    publishedDate: "2026-05-26",
    readingTime: "12 Min Lesezeit",
  },
  {
    slug: "open-source-vs-frontier",
    category: "AI Foundations",
    title:
      "Open Source vs. Frontier-Modelle: Wann sich welcher Weg für den Mittelstand lohnt",
    excerpt:
      "Open Source oder die kommerziellen Frontier-Modelle? Die Frage enthält einen Denkfehler — die Annahme, man müsse sich entscheiden. Sie sind zwei Werkzeuge mit unterschiedlichen Stärken, und die richtige Antwort ist für die meisten Unternehmen ein bewusster Mix. Die fünf Entscheidungs-Dimensionen, wann welcher Weg gewinnt — und warum die ideologische Entscheidung die teuerste ist.",
    publishedDate: "2026-05-26",
    readingTime: "10 Min Lesezeit",
  },
  {
    slug: "cli-ai-tools",
    category: "AI in der Praxis",
    title:
      "CLI-AI-Tools im Vergleich: Claude Code, Cursor, Aider, Antigravity — wann welches?",
    excerpt:
      "Die produktivste Form von KI ist kein Chat-Fenster — sie lebt im Terminal und Editor, hat Zugriff auf Dateien und Systeme, und arbeitet agentisch. Claude Code, Cursor, Aider, Antigravity. Was sie unterscheidet, für wen sie sich lohnen, und warum das längst kein reines Entwickler-Thema mehr ist — plus die Governance-Regeln, die Sie vor dem Einsatz brauchen.",
    publishedDate: "2026-05-26",
    readingTime: "10 Min Lesezeit",
  },
  {
    slug: "context-engineering",
    category: "KI in der Praxis",
    title:
      "Context-Engineering: Warum KI ohne Kontext mittelmäßig bleibt — und was Sie dem Modell über sich verraten sollten",
    excerpt:
      "Dasselbe Modell liefert dem einen Nutzer brillante, dem anderen mittelmäßige Ergebnisse — bei identischer Frage. Der Unterschied ist fast nie das Modell, sondern der Kontext. Context-Engineering ist die unterschätzteste Disziplin im KI-Einsatz. Wie sie funktioniert, was Sie teilen sollten — und wo die Datenschutz-Grenze verläuft, die Sie nie überschreiten dürfen.",
    publishedDate: "2026-05-26",
    readingTime: "9 Min Lesezeit",
  },
  {
    slug: "ki-readiness-check",
    category: "KI-Strategie",
    title:
      "Der KI-Readiness-Check: 7 Fragen, die Sie vor jeder KI-Investition beantworten müssen",
    excerpt:
      "Bevor Sie einen Euro in KI investieren, beantworten Sie sieben Fragen. Sie dauern zehn Minuten und ersparen Ihnen potenziell ein sechsstelliges Lehrgeld. Aus zwölf Mandaten: Wer alle sieben sauber beantwortet, gehört zu den 20 % der KI-Projekte, die produktiv gehen. Inklusive Auswertung.",
    publishedDate: "2026-05-26",
    readingTime: "9 Min Lesezeit",
  },
  {
    slug: "ki-im-vertrieb",
    category: "Vertrieb & KI",
    title:
      "KI im B2B-Vertrieb: Wo sie wirklich Umsatz bewegt — und wo sie Theater ist",
    excerpt:
      "Im Vertrieb wird KI als Allheilmittel verkauft und von erfahrenen Verkäufern belächelt. Beide liegen falsch. Aus über einem Jahrzehnt Vertrieb: drei Stellen, an denen KI im B2B wirklich Umsatz bewegt — und drei, an denen sie teures Theater ist. KI macht gute Verkäufer besser, nicht schlechte gut.",
    publishedDate: "2026-05-26",
    readingTime: "11 Min Lesezeit",
  },
  {
    slug: "ki-chatbots-mittelstand",
    category: "KI in der Praxis",
    title:
      "KI-Chatbots im Mittelstand: Wann sich Automatisierung lohnt — und wann sie Kunden vergrault",
    excerpt:
      "Ein KI-Chatbot ist die sichtbarste und am häufigsten falsch eingesetzte KI-Anwendung im Mittelstand. Ein schlechter Bot schadet mehr als gar keiner. Wann sich ein Kundenservice-Bot lohnt, wann er nach hinten losgeht — und die drei Bauregeln, die verhindern, dass er Kunden vergrault.",
    publishedDate: "2026-05-26",
    readingTime: "10 Min Lesezeit",
  },
  {
    slug: "lead-scoring-outbound",
    category: "Vertrieb & KI",
    title:
      "Lead-Scoring und KI-Outbound: Was im DACH-Vertrieb funktioniert — und was illegal ist",
    excerpt:
      "Zwei KI-Versprechen dominieren den B2B-Vertrieb: „die KI findet deine besten Leads“ und „die KI schreibt tausend Akquise-Mails“. Das erste funktioniert — unter einer Bedingung, die fast alle übersehen. Das zweite ist im DACH-Raum überwiegend illegal, und kaum ein Anbieter sagt es. Die ehrliche Einordnung inklusive Rechtslage (UWG § 7, DSGVO Art. 22).",
    publishedDate: "2026-05-26",
    readingTime: "11 Min Lesezeit",
  },
  {
    slug: "ki-adoption-mittelstand",
    category: "KI-Strategie",
    title:
      "Warum 80 % der KI-Pilotprojekte im DACH-Mittelstand nie produktiv gehen",
    excerpt:
      "Aus zwölf Mandaten zwischen 2023 und 2026 — von der Versicherung mit 7-stelliger AI-Investitionsfrage bis zum Logistiker, der ChatGPT-Plus-Lizenzen verteilte und sich wunderte, dass nichts skaliert: Die drei Antimuster, die ich immer wieder sehe. Und warum die meisten Beratungs-Decks am Kernproblem vorbeireden.",
    publishedDate: "2026-05-26",
    readingTime: "11 Min Lesezeit",
  },
];

const Insights = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-[#C5A66A] focus:text-[#0F1B2D] focus:px-4 focus:py-2 focus:rounded focus:font-semibold"
      >
        Zum Hauptinhalt springen
      </a>
      <Navigation />
      <main id="main-content" className="pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-5xl">
          <header className="mb-16">
            <div className="text-sm text-[#C5A66A] uppercase tracking-wider font-semibold mb-4">
              Insights
            </div>
            <h1 className="font-playfair text-5xl lg:text-6xl font-bold text-[#0F1B2D] mb-6 leading-tight">
              Strategie, KI und Mittelstand — aus der Praxis.
            </h1>
            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl">
              Keine Listicles. Keine 7-Tipps-Templates. Erkenntnisse aus
              laufenden Mandaten, eigene Daten, kontroverse Positionen. Wer
              schnell scannen will, ist falsch — wer Substanz sucht, richtig.
            </p>
          </header>

          <div className="grid gap-8">
            {INSIGHTS.map((article) => (
              <Link
                key={article.slug}
                to={`/insights/${article.slug}`}
                className="group block bg-white rounded-2xl border border-gray-200 hover:border-[#C5A66A] hover:shadow-xl transition-all duration-300 p-8"
              >
                <div className="flex items-center gap-3 text-sm text-[#C5A66A] uppercase tracking-wider font-semibold mb-4">
                  <span>{article.category}</span>
                  <span>·</span>
                  <span>{article.readingTime}</span>
                </div>
                <h2 className="font-playfair text-2xl lg:text-3xl font-bold text-[#0F1B2D] mb-4 group-hover:text-[#C5A66A] transition-colors">
                  {article.title}
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-600">
                    Daaniyal Khan
                  </div>
                  <div className="text-[#C5A66A] font-semibold group-hover:translate-x-1 transition-transform">
                    Lesen →
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <section className="mt-20 bg-gradient-to-r from-[#0F1B2D] to-[#1a2d4a] rounded-2xl p-12 text-white text-center">
            <h2 className="text-3xl font-bold mb-4 text-[#C5A66A]">
              Direkt zur Strategiediskussion
            </h2>
            <p className="text-lg mb-8 max-w-2xl mx-auto">
              Lesen ist gut, anwenden ist besser. 90 Minuten kostenloses
              Erstgespräch — danach wissen Sie, ob wir zusammenpassen.
            </p>
            <Link
              to="/#contact"
              className="inline-block bg-[#C5A66A] text-[#0F1B2D] px-8 py-4 rounded-lg font-semibold hover:bg-[#b8966b] hover:scale-105 transition-all duration-300"
            >
              Strategie-Gespräch buchen
            </Link>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Insights;